var map = {
	"./skins/IBC-dyst-2025": [
		131,
		15
	],
	"./skins/IBC-dyst-2025.css": [
		404,
		33
	],
	"./skins/IBC-dyst-2025.js": [
		131,
		15
	],
	"./skins/aktionaerliga-2024": [
		132,
		14
	],
	"./skins/aktionaerliga-2024.css": [
		405,
		32
	],
	"./skins/aktionaerliga-2024.js": [
		132,
		14
	],
	"./skins/aktionaerliga-2025": [
		133,
		13
	],
	"./skins/aktionaerliga-2025.css": [
		406,
		31
	],
	"./skins/aktionaerliga-2025.js": [
		133,
		13
	],
	"./skins/bibliotekarernes-sep-2024": [
		134,
		12
	],
	"./skins/bibliotekarernes-sep-2024.css": [
		407,
		30
	],
	"./skins/bibliotekarernes-sep-2024.js": [
		134,
		12
	],
	"./skins/boersen-spiel-sep-2024": [
		135,
		11
	],
	"./skins/boersen-spiel-sep-2024.css": [
		408,
		29
	],
	"./skins/boersen-spiel-sep-2024.js": [
		135,
		11
	],
	"./skins/borsgruppenliu-jan-2024": [
		136,
		10
	],
	"./skins/borsgruppenliu-jan-2024.css": [
		409,
		28
	],
	"./skins/borsgruppenliu-jan-2024.js": [
		136,
		10
	],
	"./skins/fynske-bank-sep-2024": [
		137,
		9
	],
	"./skins/fynske-bank-sep-2024.css": [
		410,
		27
	],
	"./skins/fynske-bank-sep-2024.js": [
		137,
		9
	],
	"./skins/ibc-jan-2024": [
		138,
		16
	],
	"./skins/ibc-jan-2024.js": [
		138,
		16
	],
	"./skins/sdu-businessschooldays-2024": [
		139,
		8
	],
	"./skins/sdu-businessschooldays-2024.css": [
		411,
		26
	],
	"./skins/sdu-businessschooldays-2024.js": [
		139,
		8
	],
	"./skins/sdu-businessschooldays-2025": [
		140,
		7
	],
	"./skins/sdu-businessschooldays-2025.css": [
		412,
		25
	],
	"./skins/sdu-businessschooldays-2025.js": [
		140,
		7
	],
	"./skins/skoledyst-oct-2023": [
		141,
		6
	],
	"./skins/skoledyst-oct-2023.css": [
		413,
		24
	],
	"./skins/skoledyst-oct-2023.js": [
		141,
		6
	],
	"./skins/skolernes-aktiedyst-2024": [
		142,
		5
	],
	"./skins/skolernes-aktiedyst-2024.css": [
		414,
		23
	],
	"./skins/skolernes-aktiedyst-2024.js": [
		142,
		5
	],
	"./skins/sommerdysten-ad-2023": [
		143,
		4
	],
	"./skins/sommerdysten-ad-2023.css": [
		415,
		22
	],
	"./skins/sommerdysten-ad-2023.js": [
		143,
		4
	],
	"./skins/sommerdysten-ak-2023": [
		144,
		3
	],
	"./skins/sommerdysten-ak-2023.css": [
		416,
		21
	],
	"./skins/sommerdysten-ak-2023.js": [
		144,
		3
	],
	"./skins/sommerdysten-is-2023": [
		145,
		2
	],
	"./skins/sommerdysten-is-2023.css": [
		417,
		20
	],
	"./skins/sommerdysten-is-2023.js": [
		145,
		2
	],
	"./skins/sydbank-sep-2020": [
		146,
		1
	],
	"./skins/sydbank-sep-2020.css": [
		418,
		19
	],
	"./skins/sydbank-sep-2020.js": [
		146,
		1
	],
	"./skins/ungdomsudddyst-oct-2024": [
		147,
		0
	],
	"./skins/ungdomsudddyst-oct-2024.css": [
		419,
		18
	],
	"./skins/ungdomsudddyst-oct-2024.js": [
		147,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 312;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/dynamic lazy ^\.\/.*$
// module id = 312
// module chunks = 34